import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { RootStoreContext } from '../stores/RootStore';
const customerIdAsKey = (WrappedComponent) => {
    return observer((props) => {
        const rootStore = useContext(RootStoreContext);
        return (React.createElement(WrappedComponent, { ...props, key: rootStore.ssoStore.customerId }, props.children));
    });
};
export default customerIdAsKey;
